import CustomHeader from "@/components/CustomHeader/CustomHeader";
import Pagination from "@/components/Table/Pagination";
import Table from "@/components/Table/Table";
import { useSearchPagination } from "@/hooks/useSearchPagination";
import { showHyphen } from "@/lib/hyphen";
import toast from "@/lib/toast";
import productCatalogueService from "@/services/api/Product Catalogue/ProductCatalogue";
import { useEffect, useState } from "react"

const ProductCatalogue = () => {
    const [catalogueData,setCatalogueData] = useState<any[]>([]);
    const [totalRecords, setTotalRecords] = useState<number | null>(null);
    
    const catalogueColumn = [
        { name: "Product Name", selector: (row: any) => row.productName },
        { name: "SKU Code", selector: (row: any) => row.skuCode },
        { name: "Scheme", selector: (row: any) => showHyphen(row.scheme) },
        { name: "Total Qty", selector: (row: any) => row.qty },  
        { name: "Dealing Price", selector: (row: any) => row.dealingPrice },  
    ];

    const {
        debouncedSearch,
        search,
        setSearch,
        pageSelected,
        setPageSelected,
        rowsPerPageValue,
        setRowsPerPageValue,
    } = useSearchPagination();

    const from = (pageSelected - 1) * rowsPerPageValue + 1;
    const to = pageSelected * rowsPerPageValue;

    const fetchProductCatalogue = async () => {
        const params = {
            from,
            to,
            search : debouncedSearch || "",
        }
        try{
            const res = await productCatalogueService.getProductCatalogueList(params);
            setCatalogueData(res?.data?.items || []);
            setTotalRecords(res?.data?.totalRecords);
        }catch(err : any){
            toast.error(err?.message);
        }
    }

    
    useEffect(() => {
        fetchProductCatalogue();
    },[pageSelected,debouncedSearch])
    return (
        <>
        <div className="p-5">
        <div className="flex justify-between items-center mb-4">
          <h2 className="text-2xl md:text-lg font-semibold">Product Catalogue</h2>
          <div className="flex items-center gap-3">
            <CustomHeader
              search={search}
              setSearch={setSearch}
            />
          </div>
        </div>
        <Table columns={catalogueColumn} data={catalogueData ?? []}/>
            <Pagination
                isPagination={true}
                totalCount={totalRecords ?? 0}
                pageSelected={pageSelected}
                setPageSelected={setPageSelected}
                rowsPerPageValue={rowsPerPageValue}
                setRowsPerPageValue={setRowsPerPageValue}
                customRowsPerPage={false}
            />
        </div>
        </>
    )
}

export default ProductCatalogue